// extracted by mini-css-extract-plugin
export default {"ggivalues":"GGIValues_ggivalues__zzhCi","ggivalues__img":"GGIValues_ggivalues__img__Atj7o"};